import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import LinearProgress from "@material-ui/core/LinearProgress";
import {CALENDAR_ES, DATE_FORMAT_CALENDAR} from "../../../utils/constants/Constants";
import {Calendar} from "primereact/calendar";
import UserDropDown from "../../../components/dropDown/user";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import {Button} from "primereact/button";
import ContextMenu from "../../../components/contextMenu";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const Bitacora = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Administración \ Bitácora"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getLog}>
                            <Grid container direction="row" justify="space-evenly" alignItems="center">
                                <Grid item xs={12}>
                                    <div className="p-grid">
                                        <div className="p-col-3">
                                            <SubtitleLabel header="Usuario" isBold={true}/>
                                            <UserDropDown
                                                name="catUserFilter"
                                                filter="descripcionId"
                                                save={props.onChangeFilters}
                                                value={props.filters.catUserFilter}
                                                loading={props.loading}
                                            />
                                        </div>
                                        <div className="p-col-3">
                                            <SubtitleLabel header="Fecha Inicial" isBold={true}/>
                                            <Calendar name="startDate"
                                                      locale={CALENDAR_ES}
                                                      dateFormat={DATE_FORMAT_CALENDAR}
                                                      disabledDays={[0, 6]}
                                                      readOnlyInput={true}
                                                      value={props.filters.startDate}
                                                      onChange={props.onChangeFilters}
                                                      maxDate={props.filters.today}
                                                      monthNavigator={true}
                                                      yearNavigator={true}
                                                      yearRange={CALENDAR_ES['yearRange']}
                                                      showButtonBar={true}
                                            />
                                        </div>
                                        <div className="p-col-3">
                                            <SubtitleLabel header="Fecha Final" isBold={true}/>
                                            <Calendar name="finalDate"
                                                      locale={CALENDAR_ES}
                                                      dateFormat={DATE_FORMAT_CALENDAR}
                                                      disabledDays={[0, 6]}
                                                      readOnlyInput={true}
                                                      value={props.filters.finalDate}
                                                      onChange={props.onChangeFilters}
                                                      minDate={props.filters.startDate}
                                                      monthNavigator={true}
                                                      yearNavigator={true}
                                                      yearRange={CALENDAR_ES['yearRange']}
                                                      showButtonBar={true}
                                            />
                                        </div>
                                        <div className="p-col-3">
                                            <br/>
                                            <Button label="Limpiar"
                                                    style={{'float': 'right'}}
                                                    onClick={props.clearFilters}
                                                    className="p-button-secondary"/>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </HeaderScreenPresval>
                    </Grid>
                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        <ContextMenu menuOptions={props.exportOptions}
                                     isButton={true}
                                     label="Exportar"/>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable
                            paginator={true}
                            lazy={true}
                            onPage={props.onPage}
                            totalRecords={props.totalRecords}
                            first={props.first}
                            rows={props.rows}
                            value={props.logList}
                            resizableColumns={true}
                            columnResizeMode={"fit"}
                        >
                            <Column field="usuario" header="Usuario" style={{textAlign: 'left'}}/>
                            <Column field="sql" header="SQL" style={{textAlign: 'left'}}/>
                            <Column field="url" header="URL" style={{textAlign: 'left'}}/>
                            <Column field="fecha" header="Fecha" style={{textAlign: 'left'}}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(Bitacora);